import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';

const SLOT_MINS = 30;
const SLOT_PX   = 80;

const APPT_COLORS = [
  '#4f6ef7','#e53935','#43a047','#fb8c00',
  '#8e24aa','#00acc1','#f4511e','#3949ab',
  '#00897b','#c0ca33','#d81b60','#546e7a'
];

@Component({
  selector: 'app-customer-schedular-list',
  templateUrl: './customer-schedular-list.component.html',
  styleUrls: ['./customer-schedular-list.component.css']
})
export class CustomerSchedularListComponent implements OnInit, AfterViewInit {

  @ViewChild('gridScroll') gridScroll: ElementRef;

  currentUser: any = {};
  model: any = { employee_id: '' };

  EMPS: any[]          = [];
  filteredEmps: any[]  = [];
  appointments: any[]  = [];
  rawData: any[]       = [];
  allRawData: any[]    = [];

  timeSlots: any[]     = [];
  currentDate: Date    = new Date();
  isToday: boolean     = true;
  nowLineLeft: number  = 0;

  viewMode: string     = 'month';

  calendarWeeks: any[][] = [];
  calendarMonth: number;
  calendarYear: number;
  dotMap: { [key: string]: number } = {};
  yearOptions: number[] = [];

  private buildYearOptions() {
    const current = new Date().getFullYear();
    this.yearOptions = [];
    for (let y = current - 3; y <= current + 2; y++) this.yearOptions.push(y);
  }

  selectedAppt: any    = null;
  selectedDayAppts: any[] = null;
  selectedDayLabel: string = '';
  showLoader: boolean  = false;

  // Hours config — 24h support
  startHour: number    = 8;
  endHour: number      = 22;

  // Drag state
  dragging: any        = null;
  dragStartX: number   = 0;
  dragStartY: number   = 0;
  dragOrigLeft: number = 0;
  dragOrigWidth: number = 0;
  dragOrigEmpIdx: number = 0;
  dragType: string     = ''; // 'move' | 'left' | 'right'
  ROW_HEIGHT: number   = 80;

  // Zoom
  zoomLevel: number    = 1;
  zoomOptions          = [0.5, 0.75, 1, 1.5, 2];

  module_access: any;
  addAccess = false; editAccess = false;
  viewAccess = false; deleteAccess = false;

  constructor(
    private router: Router,
    private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.loadModuleAccess();
    this.buildTimeSlots();
    this.buildYearOptions();
    this.loadEmps();
  }

  ngAfterViewInit() {}

  get slotPx(): number { return SLOT_PX * this.zoomLevel; }

  // ── Module access ──────────────────────────────────────────
  loadModuleAccess() {
    if (this.currentUser['module_access']) {
      try { this.module_access = JSON.parse(this.currentUser['module_access']); }
      catch(e) { this.module_access = ''; }
    }
    if (!this.checkModuleAcces('12')) {
      alert("You don't have access for this module.");
      this.router.navigate(['/Selectport']);
    }
  }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) return false;
    const arr = Array.isArray(this.module_access) ? this.module_access : JSON.parse(this.module_access);
    const mod = arr.find(m => m.module_id == module_id);
    if (mod) {
      this.addAccess    = !!mod.add;
      this.editAccess   = !!mod.edit;
      this.viewAccess   = !!mod.view;
      this.deleteAccess = !!mod.delete;
      return true;
    }
    return false;
  }

  // ── Time slots ─────────────────────────────────────────────
  buildTimeSlots() {
    this.timeSlots = [];
    const total = (this.endHour - this.startHour) * 60;
    for (let m = 0; m < total; m += SLOT_MINS) {
      const h   = this.startHour + Math.floor(m / 60);
      const min = m % 60;
      this.timeSlots.push({
        label:     min === 0 ? this.formatHour(h) : '',
        isHour:    min === 0,
        totalMins: m,
        hour:      h,
        minute:    min
      });
    }
  }

  setHours(start: number, end: number) {
    this.startHour = start;
    this.endHour   = end;
    this.buildTimeSlots();
    if (this.viewMode === 'day') this.processAppointments();
  }

  formatHour(h: number): string {
    if (h === 0 || h === 24) return '12 AM';
    if (h === 12) return '12 PM';
    return h > 12 ? `${h-12} PM` : `${h} AM`;
  }

  // ── Parse API date "dd-mm-yyyy HH:mm:ss" ──────────────────
  parseApiDate(dateStr: string): { h: number, m: number, dateKey: string } {
    const parts     = dateStr.split(' ');
    const dateParts = parts[0].split('-');
    const timeParts = parts[1] ? parts[1].split(':') : ['0','0','0'];
    return {
      h:       parseInt(timeParts[0]),
      m:       parseInt(timeParts[1]),
      dateKey: `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
    };
  }

  // ── Load employees ─────────────────────────────────────────
  loadEmps() {
    this.loginservice.getemp('', this.currentUser).subscribe(data => {
      this.EMPS         = data['comp_details'] || [];
      this.filteredEmps = [...this.EMPS];
      this.loadAllForMonth();
    }, () => alert('Network Error getemp API'));
  }

  // ── Month data ─────────────────────────────────────────────
  loadAllForMonth() {
    this.showLoader = true;
    this.loginservice.getschedulerList('', '', this.model, this.currentUser).subscribe(data => {
      this.allRawData = data['comp_details'] || [];
      this.buildDotMap();
      this.buildMonthCalendar();
      this.showLoader = false;
    }, () => { alert('Network Error getschedulerList API'); this.showLoader = false; });
  }

  buildDotMap() {
    this.dotMap = {};
    this.allRawData.forEach(item => {
      const { dateKey } = this.parseApiDate(item.scheduled_date);
      this.dotMap[dateKey] = (this.dotMap[dateKey] || 0) + 1;
    });
  }

  getDotCount(k: string): number { return this.dotMap[k] || 0; }

  // ── Employee stats for month view ──────────────────────────
  getMonthEmpStats(): any[] {
    const map: { [id: string]: { name: string, totalMins: number, activeMins: number, count: number } } = {};
    // Filter to current calendar month/year only
    this.allRawData
      .filter(item => {
        const { dateKey } = this.parseApiDate(item.scheduled_date);
        const d = new Date(dateKey);
        const matchMonth = d.getFullYear() === this.calendarYear && d.getMonth() === this.calendarMonth;
        const matchEmp   = !this.model.employee_id || String(item.employee_id) === String(this.model.employee_id);
        return matchMonth && matchEmp;
      })
      .forEach(item => {
        const id   = String(item.employee_id);
        const name = item.employee_name || id;
        if (!map[id]) map[id] = { name, totalMins: 0, activeMins: 0, count: 0 };
        map[id].totalMins  += parseInt(item.duration_minutes) || 0;
        map[id].activeMins += parseInt(item.employee_active_minutes) || 0;
        map[id].count++;
      });
    return Object.values(map).sort((a, b) => b.totalMins - a.totalMins);
  }

  // ── Employee stats for day view ───────────────────────────
  getDayEmpStats(): any[] {
    const map: { [id: string]: { name: string, totalMins: number, activeMins: number, count: number } } = {};
    (this.rawData || [])
      .filter(item => !this.model.employee_id || String(item.employee_id) === String(this.model.employee_id))
      .forEach(item => {
        const id   = String(item.employee_id);
        const name = item.employee_name || id;
        if (!map[id]) map[id] = { name, totalMins: 0, activeMins: 0, count: 0 };
        map[id].totalMins  += parseInt(item.duration_minutes) || 0;
        map[id].activeMins += parseInt(item.employee_active_minutes) || 0;
        map[id].count++;
      });
    return Object.values(map).sort((a, b) => b.totalMins - a.totalMins);
  }

  minsToHHMM(mins: number): string {
    if (!mins) return '0h 0m';
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
  }

  buildMonthCalendar() {
    const d = new Date(this.currentDate);
    this.calendarMonth = d.getMonth();
    this.calendarYear  = d.getFullYear();
    const firstDay     = new Date(this.calendarYear, this.calendarMonth, 1);
    const lastDay      = new Date(this.calendarYear, this.calendarMonth + 1, 0);
    const weeks: any[][] = [];
    let week: any[] = [];
    for (let i = 0; i < firstDay.getDay(); i++) week.push(null);
    for (let day = 1; day <= lastDay.getDate(); day++) {
      const dateObj = new Date(this.calendarYear, this.calendarMonth, day);
      week.push({ day, date: dateObj, key: this.formatDateKey(dateObj), isToday: this.isSameDay(dateObj, new Date()) });
      if (week.length === 7) { weeks.push(week); week = []; }
    }
    if (week.length > 0) { while (week.length < 7) week.push(null); weeks.push(week); }
    this.calendarWeeks = weeks;
  }

  formatDateKey(d: Date): string {
    return `${d.getFullYear()}-${('0'+(d.getMonth()+1)).slice(-2)}-${('0'+d.getDate()).slice(-2)}`;
  }

  isSameDay(a: Date, b: Date): boolean {
    return a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth() && a.getDate()===b.getDate();
  }

  selectDate(cell: any) {
    if (!cell) return;
    this.currentDate = new Date(cell.date);
    const count = this.getDotCount(cell.key);
    if (count === 0) {
      // No appointments — go straight to day view
      this.viewMode = 'day';
      this.loadDaySchedules();
      return;
    }
    // Show day-appointments picker modal
    const dayAppts = this.allRawData.filter(item => {
      const { dateKey } = this.parseApiDate(item.scheduled_date);
      return dateKey === cell.key &&
        (!this.model.employee_id || String(item.employee_id) === String(this.model.employee_id));
    });
    this.selectedDayLabel = new Date(cell.date).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
    this.selectedDayAppts = dayAppts.map(item => {
      const { h, m } = this.parseApiDate(item.scheduled_date);
      const dur = parseInt(item.duration_minutes) || 60;
      const endTotal = h * 60 + m + dur;
      return {
        id:           item.scheduler_id || item.id,
        customerName: item.f_name,
        phone:        item.cusPhone || '',
        service:      item.customer_description,
        empName:      item.employee_name,
        startLabel:   this.formatTime(h, m),
        endLabel:     this.formatTime(Math.floor(endTotal / 60), endTotal % 60),
        duration:     dur,
        notes:        item.desc_cust || ''
      };
    });
  }

  closeDayModal() { this.selectedDayAppts = null; }

  openDayView() {
    this.selectedDayAppts = null;
    this.viewMode = 'day';
    this.loadDaySchedules();
  }

  selectDayAppt(appt: any) {
    this.selectedDayAppts = null;
    this.selectedAppt = appt;
  }

  deleteDayAppt(id: number) {
    if (confirm('Are you sure you want to delete this appointment?')) {
      this.loginservice.deletegridData(id, 'id', 'scheduler', 'status').subscribe(() => {
        this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
        this.selectedDayAppts = null;
        this.loadAllForMonth();
      }, () => alert('Network Error delete API'));
    }
  }

  changeMonth(delta: number) {
    const d = new Date(this.currentDate);
    d.setDate(1); d.setMonth(d.getMonth() + delta);
    this.currentDate = d; this.loadAllForMonth();
  }

  goMonthToday() { this.currentDate = new Date(); this.loadAllForMonth(); }

  jumpToMonth() {
    const m = parseInt(String(this.calendarMonth), 10);
    const y = parseInt(String(this.calendarYear), 10);
    this.calendarMonth = m;
    this.calendarYear  = y;
    this.currentDate   = new Date(y, m, 1);
    this.loadAllForMonth();
  }

  backToMonth() { this.viewMode = 'month'; this.selectedAppt = null; this.loadAllForMonth(); }

  // ── Day view ───────────────────────────────────────────────
  loadDaySchedules() {
    const dateStr = this.formatDateForApi(this.currentDate);
    this.showLoader = true;
    this.loginservice.getschedulerList('', dateStr, this.model, this.currentUser).subscribe(data => {
      this.rawData = data['comp_details'] || [];
      this.processAppointments();
      this.updateNowLine();
      this.showLoader = false;
      setTimeout(() => this.scrollToNow(), 200);
    }, () => { alert('Network Error getschedulerList API'); this.showLoader = false; });
  }

  formatDateForApi(d: Date): string {
    return `${d.getFullYear()}-${('0'+(d.getMonth()+1)).slice(-2)}-${('0'+d.getDate()).slice(-2)}`;
  }

  processAppointments() {
    const colorMap: any = {};
    let colorIdx = 0;
    const sp = this.slotPx;
    const SUB_ROW_H = 52; // height per sub-row inside a row

    // First pass: build base objects
    const appts = (this.rawData || []).map(item => {
      const { h: startH, m: startM } = this.parseApiDate(item.scheduled_date);
      const duration       = item.duration_minutes ? parseInt(item.duration_minutes) : 60;
      const activeDuration = item.employee_active_minutes ? parseInt(item.employee_active_minutes) : 0;
      const startMins      = (startH - this.startHour) * 60 + startM;
      const leftPx         = (startMins / SLOT_MINS) * sp;
      const widthPx        = Math.max((duration / SLOT_MINS) * sp - 4, 44);
      // Always at least 12px so drag handle is always visible
      const activePx       = Math.max((activeDuration / SLOT_MINS) * sp, 12);
      const endTotal       = startH * 60 + startM + duration;

      // Each appointment gets its own unique color based on its ID
      const colorIndex = parseInt(item.scheduler_id || item.id) % APPT_COLORS.length;
      const apptColor  = APPT_COLORS[colorIndex];

      return {
        id:           item.scheduler_id || item.id,
        empId:        String(item.employee_id),
        empName:      item.employee_name,
        customerName: item.f_name,
        phone:        item.cusPhone || '',
        service:      item.customer_description,
        serviceId:    item.customer_description_id || item.id,
        notes:        item.desc_cust || '',
        startLabel:   this.formatTime(startH, startM),
        endLabel:     this.formatTime(Math.floor(endTotal/60), endTotal%60),
        leftPx:       Math.max(leftPx, 0),
        widthPx,
        activePx,
        color:        apptColor,
        duration,
        activeDuration,
        startH,
        startM,
        startMins:    startH * 60 + startM,
        endMins:      startH * 60 + startM + duration,
        subRow:       0,
        totalSubRows: 1,
        topPx:        0
      };
    });

    // Second pass: assign sub-rows per employee to avoid overlap
    const empGroups: { [empId: string]: any[] } = {};
    appts.forEach(a => {
      if (!empGroups[a.empId]) empGroups[a.empId] = [];
      empGroups[a.empId].push(a);
    });

    Object.keys(empGroups).forEach(empId => {
      const group = empGroups[empId].sort((a, b) => a.startMins - b.startMins);
      const subRowEnds: number[] = [];
      group.forEach(appt => {
        let placed = false;
        for (let r = 0; r < subRowEnds.length; r++) {
          if (appt.startMins >= subRowEnds[r]) {
            appt.subRow = r;
            subRowEnds[r] = appt.endMins;
            placed = true;
            break;
          }
        }
        if (!placed) {
          appt.subRow = subRowEnds.length;
          subRowEnds.push(appt.endMins);
        }
      });
      const maxSubRows = Math.max(subRowEnds.length, 1);
      group.forEach(a => {
        a.totalSubRows = maxSubRows;
        a.topPx = 4 + a.subRow * SUB_ROW_H;
        // height shrinks per sub-row
        a.heightPx = SUB_ROW_H - 8;
      });
    });

    this.appointments = appts;
  }

  formatTime(h: number, m: number): string {
    if (h === 0) return `12:${('0'+m).slice(-2)} AM`;
    if (h === 12) return `12:${('0'+m).slice(-2)} PM`;
    return h > 12 ? `${h-12}:${('0'+m).slice(-2)} PM` : `${h}:${('0'+m).slice(-2)} AM`;
  }

  getEmpAppts(empId: any): any[] {
    return this.appointments.filter(a => a.empId == empId);
  }

  getRowHeight(empId: any): number {
    const appts = this.getEmpAppts(empId);
    if (!appts.length) return 80;
    const maxSubRow = Math.max(...appts.map(a => a.subRow || 0));
    return Math.max(80, (maxSubRow + 1) * 52 + 8);
  }

  updateNowLine() {
    const now = new Date();
    this.isToday = this.isSameDay(now, this.currentDate);
    if (this.isToday) {
      const mins = (now.getHours() - this.startHour) * 60 + now.getMinutes();
      this.nowLineLeft = (mins / SLOT_MINS) * this.slotPx;
    }
  }

  scrollToNow() {
    if (this.gridScroll && this.isToday) {
      this.gridScroll.nativeElement.scrollLeft = Math.max(this.nowLineLeft - 200, 0);
    }
  }

  changeDay(delta: number) {
    const d = new Date(this.currentDate);
    d.setDate(d.getDate() + delta);
    this.currentDate = d; this.loadDaySchedules();
  }

  goToday() { this.currentDate = new Date(); this.loadDaySchedules(); }

  filterByEmployee() {
    this.filteredEmps = this.model.employee_id
      ? this.EMPS.filter(e => e.id == this.model.employee_id)
      : [...this.EMPS];
    if (this.viewMode === 'day') {
      this.processAppointments();
    } else {
      // Rebuild dot map filtered by employee
      this.dotMap = {};
      this.allRawData
        .filter(item => !this.model.employee_id || String(item.employee_id) === String(this.model.employee_id))
        .forEach(item => {
          const { dateKey } = this.parseApiDate(item.scheduled_date);
          this.dotMap[dateKey] = (this.dotMap[dateKey] || 0) + 1;
        });
    }
  }

  reset() {
    this.model.employee_id = '';
    this.filteredEmps      = [...this.EMPS];
    this.currentDate       = new Date();
    this.viewMode          = 'month';
    this.loadAllForMonth();
  }

  onSlotClick(emp: any, slot: any) {
    if (!this.addAccess || this.dragging) return;
    const existing = this.appointments.find(a =>
      a.empId == emp.id && a.startH === slot.hour && Math.abs(a.startM - slot.minute) < SLOT_MINS
    );
    if (existing) this.router.navigate(['/customer-scheduler', existing.id]);
    else this.router.navigate(['/customer-scheduler']);
  }

  openAppt(appt: any, event: Event) {
    if (this.dragging) return;
    event.stopPropagation();
    this.selectedAppt = appt;
  }

  closeModal() { this.selectedAppt = null; }
  addvendor()  { this.router.navigate(['customer-scheduler']); }

  delete(id: number) {
    if (confirm('Are you sure you want to delete this appointment?')) {
      this.loginservice.deletegridData(id, 'id', 'scheduler', 'status').subscribe(() => {
        this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
        this.selectedAppt = null;
        if (this.viewMode === 'day') this.loadDaySchedules();
        else this.loadAllForMonth();
      }, () => alert('Network Error delete API'));
    }
  }

  // ── Zoom ───────────────────────────────────────────────────
  zoomIn()  {
    const i = this.zoomOptions.indexOf(this.zoomLevel);
    if (i < this.zoomOptions.length - 1) { this.zoomLevel = this.zoomOptions[i+1]; this.processAppointments(); }
  }
  zoomOut() {
    const i = this.zoomOptions.indexOf(this.zoomLevel);
    if (i > 0) { this.zoomLevel = this.zoomOptions[i-1]; this.processAppointments(); }
  }

  // ── DRAG MOVE (whole block) ────────────────────────────────
  onDragMove(event: MouseEvent, appt: any) {
    event.stopPropagation();
    event.preventDefault();
    this.dragging        = appt;
    this.dragType        = 'move';
    this.dragStartX      = event.clientX;
    this.dragStartY      = event.clientY;
    this.dragOrigLeft    = appt.leftPx;
    this.dragOrigEmpIdx  = this.filteredEmps.findIndex(e => e.id == appt.empId);

    const onMove = (e: MouseEvent) => {
      const sp      = this.slotPx;
      const deltaX  = e.clientX - this.dragStartX;
      const deltaY  = e.clientY - this.dragStartY;

      // Horizontal: shift time
      const newLeft = Math.max(this.dragOrigLeft + deltaX, 0);
      appt.leftPx   = newLeft;
      const minsFromStart = Math.round((newLeft / sp) * SLOT_MINS);
      const totalMins     = this.startHour * 60 + minsFromStart;
      appt.startH   = Math.floor(totalMins / 60);
      appt.startM   = totalMins % 60;
      appt.startLabel = this.formatTime(appt.startH, appt.startM);
      const endTotal = appt.startH * 60 + appt.startM + appt.duration;
      appt.endLabel  = this.formatTime(Math.floor(endTotal/60), endTotal%60);

      // Vertical: change employee row
      const rowDelta = Math.round(deltaY / this.ROW_HEIGHT);
      const newIdx   = Math.max(0, Math.min(this.filteredEmps.length - 1, this.dragOrigEmpIdx + rowDelta));
      const newEmp   = this.filteredEmps[newIdx];
      if (newEmp) {
        appt.empId   = String(newEmp.id);
        appt.empName = newEmp.f_name;
      }

      this.cdRef.detectChanges();
    };

    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      this.saveApptChanges(appt);
      setTimeout(() => { this.dragging = null; }, 100);
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  }

  // ── DRAG RIGHT edge ────────────────────────────────────────
  onResizeRight(event: MouseEvent, appt: any) {
    event.stopPropagation();
    event.preventDefault();
    this.dragging      = appt;
    this.dragType      = 'right';
    this.dragStartX    = event.clientX;
    this.dragOrigWidth = appt.widthPx;

    const onMove = (e: MouseEvent) => {
      const sp       = this.slotPx;
      const newWidth = Math.max(this.dragOrigWidth + (e.clientX - this.dragStartX), sp / 2);
      appt.widthPx   = newWidth;
      appt.duration  = Math.round((newWidth / sp) * SLOT_MINS);
      const endTotal = appt.startH * 60 + appt.startM + appt.duration;
      appt.endLabel  = this.formatTime(Math.floor(endTotal/60), endTotal%60);
      this.cdRef.detectChanges();
    };
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      this.saveApptChanges(appt);
      setTimeout(() => { this.dragging = null; }, 100);
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  }

  // ── DRAG LEFT edge ─────────────────────────────────────────
  onResizeLeft(event: MouseEvent, appt: any) {
    event.stopPropagation();
    event.preventDefault();
    this.dragging      = appt;
    this.dragType      = 'left';
    this.dragStartX    = event.clientX;
    this.dragOrigLeft  = appt.leftPx;
    this.dragOrigWidth = appt.widthPx;

    const onMove = (e: MouseEvent) => {
      const sp      = this.slotPx;
      const delta   = e.clientX - this.dragStartX;
      const newLeft = Math.max(this.dragOrigLeft + delta, 0);
      appt.leftPx   = newLeft;
      appt.widthPx  = Math.max(this.dragOrigWidth - delta, sp / 2);
      const minsFromStart = Math.round((newLeft / sp) * SLOT_MINS);
      const totalMins     = this.startHour * 60 + minsFromStart;
      appt.startH   = Math.floor(totalMins / 60);
      appt.startM   = totalMins % 60;
      appt.startLabel = this.formatTime(appt.startH, appt.startM);
      appt.duration = Math.round((appt.widthPx / sp) * SLOT_MINS);
      const endTotal = appt.startH * 60 + appt.startM + appt.duration;
      appt.endLabel  = this.formatTime(Math.floor(endTotal/60), endTotal%60);
      this.cdRef.detectChanges();
    };
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      this.saveApptChanges(appt);
      setTimeout(() => { this.dragging = null; }, 100);
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  }

  // ── DRAG active duration bar ──────────────────────────────
  onResizeActive(event: MouseEvent, appt: any) {
    event.stopPropagation();
    event.preventDefault();
    this.dragging      = appt;
    this.dragStartX    = event.clientX;
    const origActivePx = appt.activePx;

    const onMove = (e: MouseEvent) => {
      const sp          = this.slotPx;
      const delta       = e.clientX - this.dragStartX;
      // Allow from 0 — clamp between 12 (min visible) and widthPx
      const newActivePx = Math.max(12, Math.min(origActivePx + delta, appt.widthPx - 4));
      appt.activePx     = newActivePx;
      // Only count as real duration if dragged past minimum
      appt.activeDuration = newActivePx <= 12 ? 0 : Math.round((newActivePx / sp) * SLOT_MINS);
      this.cdRef.detectChanges();
    };
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      this.saveActiveDuration(appt);
      setTimeout(() => { this.dragging = null; }, 100);
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  }

  saveActiveDuration(appt: any) {
    const dateStr = this.formatDateForApi(this.currentDate);
    const payload: any = {
      scheduler_id:            appt.id,
      duration_minutes:        appt.duration,
      employee_active_minutes: appt.activeDuration,
      scheduled_date:          `${dateStr} ${('0'+appt.startH).slice(-2)}:${('0'+appt.startM).slice(-2)}:00`,
      f_name:                  appt.customerName,
      customer_description:    appt.service || 'N/A'
    };
    const emp = { employee_id: appt.empId };
    this.loginservice.savescheduler(payload, emp, this.currentUser).subscribe(
      () => this._flashMessagesService.show('Working time updated', { cssClass: 'alert-success' }),
      () => {}
    );
  }
  saveApptChanges(appt: any) {
    const dateStr = this.formatDateForApi(this.currentDate);
    const newDateTime = `${dateStr} ${('0'+appt.startH).slice(-2)}:${('0'+appt.startM).slice(-2)}:00`;

    // Find original raw item to get customer_id and service_category_id
    const raw = this.rawData.find(r => (r.scheduler_id || r.id) == appt.id);
    const customerId = raw ? raw.customer_id : '';
    const serviceId  = raw ? raw.customer_description_id || raw.id : '';

    const payload: any = {
      scheduler_id:     appt.id,
      duration_minutes: appt.duration,
      scheduled_date:   newDateTime,
      f_name:           appt.customerName,
      // Pass customer_description as the service name (PHP verifyRequiredParams checks this)
      customer_description: appt.service || 'N/A',
      id:               customerId
    };

    const emp = { employee_id: appt.empId };
    this.loginservice.savescheduler(payload, emp, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show('Updated', { cssClass: 'alert-success' });
        }
      },
      () => {}
    );
  }

  get monthName(): string {
    return new Date(this.calendarYear, this.calendarMonth, 1)
      .toLocaleString('default', { month: 'long', year: 'numeric' });
  }

  getschedulerList(id, date) { this.loadAllForMonth(); }
}



// WEBPACK FOOTER //
// ./src/app/customer-schedular-list/customer-schedular-list.component.ts